/* AGC hero fit finder — A/B/C tested via PostHog feature flag `hero-fit-finder-arms`.
   Flag keys match the Shopify archive themes; internally they map to:
   old_fit_finder -> control : the pill hands off to the compatibility modal.
   new_fit_finder -> test    : the inline flow (type -> pick gun -> caliber -> cans
                                that fit, one-click add to cart) right on the hero.
   no_fit_finder  -> none    : no fit finder on the hero at all (pill stays hidden).
   The arm is resolved once at page load (exposure = seeing the hero) and locked
   for the page. The pill starts hidden in the markup and is only revealed for
   control/test, so the "none" arm never flashes it. If PostHog never answers
   (blocked, offline) the shopper gets control after a short wait and is simply
   not in the experiment. window.posthog is resolved at call time, never cached
   (the snippet swaps the global once array.js lands). Plain script, no import(). */
(function () {
  var FLAG = 'hero-fit-finder-arms';
  var FLAG_WAIT_MS = 2500;
  var API = 'https://airgun-compat-api.vercel.app';
  // .510 is the groove/slug diameter of a .50 barrel; the API aliases it to .50.
  var CALS = ['.177', '.22', '.25', '.30', '.357', '.45', '.50', '.510'];
  // Card copy, house voice. Facts only: sizes, baffles and caliber limits as sold.
  var BLURBS = {
    falcon: 'The slimmest body we make. Five baffles in a 1.25 inch tube, so it adds the least length and weight out front. Made for .177 through .30.',
    hawk: 'Same 2 inch body as the Eagle, cut to 4.5 inches. More volume than the Falcon without much extra length, and it handles power up to .357.',
    eagle: 'The longest and quietest one we make. 8 inches of baffle stack for high power guns, and the only body that takes .45 and .50.'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cleanName(t) {
    return String(t || '')
      .replace(/\s*\((?:[^()]*\.\d{2,3}[^()]*)\)/g, '')
      .replace(/\s*\B\.\d{2,3}(?:\s*(?:cal|caliber))?\b/gi, '')
      .replace(/\s{2,}/g, ' ').trim();
  }
  function highlight(label, q) {
    var words = q.trim().split(/\s+/).filter(Boolean).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return esc(label);
    return esc(label).replace(new RegExp('(' + words.join('|') + ')', 'ig'), '<mark>$1</mark>');
  }

  // ---- experiment arm ------------------------------------------------------
  var lockedArm = null;
  function readFlag() {
    try {
      if (window.posthog && window.posthog.getFeatureFlag) {
        var v = window.posthog.getFeatureFlag(FLAG); // also emits $feature_flag_called (= exposure)
        if (v === 'new_fit_finder' || v === 'test' || v === 'inline') return 'test';
        if (v === 'old_fit_finder' || v === 'control') return 'control';
        if (v === 'no_fit_finder' || v === 'none') return 'none';
      }
    } catch (e) {}
    return null;
  }
  // Resolve the arm once: immediately if flags are already in, otherwise on
  // posthog's onFeatureFlags callback, with a timeout fallback to control.
  function resolveArm(cb) {
    var done = false;
    function finish(v) {
      if (done) return; done = true;
      lockedArm = v || 'control';
      cb(lockedArm);
    }
    var v = readFlag();
    if (v) { finish(v); return; }
    try {
      if (window.posthog && window.posthog.onFeatureFlags) {
        window.posthog.onFeatureFlags(function () { finish(readFlag()); });
      }
    } catch (e) {}
    setTimeout(function () { finish(readFlag()); }, FLAG_WAIT_MS);
  }
  function arm() { return lockedArm || 'control'; }
  function phCapture(name, props) {
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(name, props); } catch (e) {}
  }

  function boot() {
    var wrap = document.querySelector('[data-agc-herofind]');
    if (!wrap) return;
    var TRACK_URL = wrap.getAttribute('data-track') || '';
    if (wrap.getAttribute('data-api')) API = wrap.getAttribute('data-api');

    var input = wrap.querySelector('[data-agc-herofind-input]');
    var go = wrap.querySelector('[data-agc-herofind-go]');
    var clearBtn = wrap.querySelector('[data-agc-hf-clear]');
    var list = wrap.querySelector('[data-agc-hf-list]');
    var calStep = wrap.querySelector('[data-agc-hf-cal]');
    var calChips = wrap.querySelector('[data-agc-hf-cal-chips]');
    var odStep = wrap.querySelector('[data-agc-hf-od]');
    var odChips = wrap.querySelector('[data-agc-hf-od-chips]');
    var result = wrap.querySelector('[data-agc-hf-result]');
    var gapForm = wrap.querySelector('[data-agc-hf-gapform]') || document.getElementById('agc-hero-gap-form');

    // Control needs the modal on the page. Without it, everyone gets inline.
    var modalTrigger = document.querySelector('[data-agc-compat2-open]');
    var modalSearch = document.querySelector('[data-agc-search]');
    var modalAvailable = !!(modalTrigger && modalSearch);

    var state = { gun: null, cal: null, od: null, rec: null, withAdapter: true, matches: [], active: 0, added: false };
    // Reveal the pill only for the arms that have one. "none" keeps it hidden.
    resolveArm(function (a) {
      if (a === 'none') {
        wrap.hidden = true;
        // Without the pill the hero would sit ~110px shorter than the other
        // arms; keep it the same height so the arms differ only in the finder.
        var hero = wrap.closest('.ac-home-hero'); if (hero) hero.classList.add('ac-home-hero--nofit');
        phCapture('fit_finder_hidden', { src: 'hero', variant: 'none' });
        return;
      }
      wrap.hidden = false;
    });

    function track(ev, data) {
      data = Object.assign({ src: 'hero', variant: lockedArm || 'unknown' }, data || {});
      phCapture('fit_finder_' + ev, data);
      try {
        if (!TRACK_URL) return;
        var body = JSON.stringify({ ev: ev, data: data, t: Date.now() });
        if (navigator.sendBeacon) navigator.sendBeacon(TRACK_URL, new Blob([body], { type: 'text/plain' }));
        else fetch(TRACK_URL, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' });
      } catch (e) {}
    }

    function isInline() {
      if (!modalAvailable) { lockedArm = 'test'; return true; }
      return arm() === 'test';
    }

    // ---- CONTROL: hand off to the modal ---------------------------------
    function handOffToModal() {
      var q = input.value.trim();
      if (!q) { input.focus(); return; }
      wrap.classList.add('is-sending');
      setTimeout(function () { wrap.classList.remove('is-sending'); }, 320);
      track('handoff', { q: q });
      modalTrigger.click();
      // Let the modal open and focus itself before seeding, otherwise its own
      // open routine clears the field we just filled.
      setTimeout(function () {
        modalSearch.value = q;
        modalSearch.dispatchEvent(new Event('input', { bubbles: true }));
        modalSearch.focus();
      }, 80);
    }

    // ---- TEST: inline flow -----------------------------------------------
    var searchT, lastQ = '', reqSeq = 0;
    function syncFilled() { wrap.classList.toggle('is-filled', !!input.value.trim() && !state.gun); }
    function closeList() { list.hidden = true; list.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); }

    function renderList(results, q) {
      state.matches = results; state.active = 0;
      list.innerHTML = '';
      if (!results.length) {
        var li = document.createElement('li');
        li.className = 'ac-hero-fit__none';
        li.innerHTML = 'No match for "' + esc(q) + '". <button type="button" data-agc-hf-notfound>Tell me your airgun</button>';
        li.querySelector('[data-agc-hf-notfound]').addEventListener('mousedown', function (e) {
          e.preventDefault();
          closeList();
          showGap('We don\'t have the <strong>' + esc(q) + '</strong> in the database yet. Leave your email and I\'ll work out a fit for it.', { gun: q, reason: 'notfound' });
          track('gap_notfound', { q: q });
        });
        list.appendChild(li);
      } else {
        results.forEach(function (g, i) {
          var li = document.createElement('li');
          li.className = 'ac-hero-fit__item' + (i === 0 ? ' is-active' : '');
          li.setAttribute('role', 'option');
          li.id = 'ac-hero-fit-opt-' + i;
          li.innerHTML = '<span>' + highlight(g.label, q) + '</span>';
          li.addEventListener('mousedown', function (e) { e.preventDefault(); pickGun(g); });
          li.addEventListener('mousemove', function () { setActive(i); });
          list.appendChild(li);
        });
      }
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(i) {
      var items = list.querySelectorAll('.ac-hero-fit__item');
      if (!items.length) return;
      state.active = (i + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === state.active); });
      input.setAttribute('aria-activedescendant', 'ac-hero-fit-opt-' + state.active);
      var el = items[state.active];
      if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function search(q, cb) {
      var seq = ++reqSeq;
      fetch(API + '/api/search?q=' + encodeURIComponent(q))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (seq !== reqSeq) return;
          var res = d.results || [];
          renderList(res, q);
          if (q !== lastQ) { track('search', { q: q }); lastQ = q; }
          if (cb) cb(res);
        })
        .catch(function () { closeList(); if (cb) cb(null); });
    }

    input.addEventListener('input', function () {
      var inline = isInline();
      if (state.gun) { unpick(); }
      syncFilled();
      if (!inline) return; // control: just show the arrow, the modal does the rest
      var q = input.value.trim();
      clearTimeout(searchT);
      if (q.length < 2) { closeList(); return; }
      searchT = setTimeout(function () { search(q); }, 150);
    });

    input.addEventListener('focus', function () {
      if (!isInline()) return;
      if (!state.gun && input.value.trim().length >= 2 && state.matches.length) renderList(state.matches, input.value.trim());
    });
    input.addEventListener('blur', function () { setTimeout(closeList, 120); });

    input.addEventListener('keydown', function (e) {
      if (!isInline()) {
        if (e.key === 'Enter') { e.preventDefault(); handOffToModal(); }
        return;
      }
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden && input.value.trim().length >= 2) search(input.value.trim()); else setActive(state.active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(state.active - 1); }
      else if (e.key === 'Escape') { closeList(); }
      else if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });

    function submit() {
      if (!isInline()) { handOffToModal(); return; }
      if (state.gun) return;
      var q = input.value.trim();
      if (!q) { input.focus(); return; }
      if (!list.hidden && state.matches[state.active]) { pickGun(state.matches[state.active]); return; }
      clearTimeout(searchT);
      search(q, function (res) { if (res && res.length) pickGun(res[0]); });
    }
    go.addEventListener('click', submit);

    function pickGun(g) {
      state.gun = g; state.cal = null; state.od = null; state.rec = null; state.added = false;
      input.value = cleanName(g.label);
      wrap.classList.add('is-picked'); wrap.classList.remove('is-filled');
      closeList();
      hideResult(); odStep.hidden = true;
      renderCalChips();
      calStep.hidden = false;
      track('gun_select', { gun: g.label });
      var first = calChips.querySelector('button');
      if (first) { first.focus({ preventScroll: true }); }
      calStep.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function unpick() {
      state.gun = null; state.cal = null; state.od = null; state.rec = null;
      wrap.classList.remove('is-picked', 'has-result');
      calStep.hidden = true; odStep.hidden = true; hideResult();
    }

    function reset() {
      unpick();
      input.value = ''; syncFilled(); closeList();
      input.focus();
    }
    clearBtn.addEventListener('click', reset);

    function renderCalChips() {
      calChips.innerHTML = '';
      CALS.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ac-hero-fit__chip'; b.textContent = c;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { chooseCal(c); });
        calChips.appendChild(b);
      });
    }

    function markChips(container, value) {
      container.querySelectorAll('.ac-hero-fit__chip').forEach(function (b) {
        var on = b.getAttribute('data-v') === value || b.textContent === value;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function chooseCal(c) {
      state.cal = c; state.od = null;
      markChips(calChips, c);
      odStep.hidden = true;
      fetchRec();
    }

    var recSeq = 0;
    function fetchRec() {
      if (!state.gun || !state.cal) return;
      var seq = ++recSeq;
      showResult('<div class="ac-hero-fit__loading">Checking what fits your ' + esc(cleanName(state.gun.label)) + '&hellip;</div>');
      var url = API + '/api/recommend?id=' + encodeURIComponent(state.gun.id) + '&cal=' + encodeURIComponent(state.cal);
      if (state.od) url += '&od=' + encodeURIComponent(state.od);
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (rec) {
          if (seq !== recSeq) return;
          state.rec = rec;
          handleRec(rec);
        })
        .catch(function () {
          if (seq !== recSeq) return;
          showResult('<p class="ac-hero-fit__msg">Couldn\'t reach the fit database. <button type="button" class="ac-hero-fit__retry" data-agc-hf-retry>Try again</button></p>');
          result.querySelector('[data-agc-hf-retry]').addEventListener('click', fetchRec);
        });
    }

    function handleRec(rec) {
      var gun = cleanName(rec.label || state.gun.label);
      var kind = rec.kind;
      var base = { gun: state.gun.label, cal: state.cal, outcome: kind };

      if (kind === 'need_caliber') {
        showResult('<p class="ac-hero-fit__msg">Pick a caliber above and I\'ll show what fits.</p>');
        return;
      }
      if (kind === 'need_od') {
        renderOdChips(rec.ods || []);
        showResult('<p class="ac-hero-fit__msg">Your <strong>' + esc(gun) + '</strong> has an unthreaded barrel, so it takes a slip-on adapter. Pick your barrel\'s outside diameter above.</p>' +
          '<p class="ac-hero-fit__why">Measure the outside of the bare barrel with calipers and pick the closest.</p>');
        track('result', base);
        return;
      }
      if (kind === 'gap' || kind === 'caliber_out') {
        showGap('I haven\'t confirmed a fit for the <strong>' + esc(gun) + '</strong> in ' + esc(state.cal) + ' yet. Leave your email and I\'ll work one out.', { gun: state.gun.label, cal: state.cal, reason: kind });
        track('result', base);
        return;
      }
      if (kind === 'no_fit') {
        showGap('An adapter fits your <strong>' + esc(gun) + '</strong>, but we don\'t make a suppressor for it in ' + esc(state.cal) + ' yet. Tell me your setup and I\'ll sort out the right option.', { gun: state.gun.label, cal: state.cal, reason: kind });
        track('result', base);
        return;
      }
      if (kind === 'direct' || kind === 'adapter' || kind === 'sourced') {
        renderFit(rec, gun);
        track('result', Object.assign(base, { thread: rec.thread }));
        return;
      }
      showGap('Something went wrong looking that up. Tell me your setup and I\'ll help directly.', { gun: state.gun.label, cal: state.cal, reason: 'unexpected:' + (kind || rec.error || 'none') });
    }

    function renderOdChips(ods) {
      odChips.innerHTML = '';
      ods.forEach(function (od) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ac-hero-fit__chip'; b.textContent = od + ' mm';
        b.setAttribute('data-v', String(od)); b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { state.od = od; markChips(odChips, String(od)); fetchRec(); });
        odChips.appendChild(b);
      });
      odStep.hidden = false;
    }

    function moneyVal(s) { var m = String(s || '').match(/[\d.,]+/); return m ? parseFloat(m[0].replace(/,/g, '')) : 0; }

    function renderFit(rec, gun) {
      var opts = (rec.options || []).slice().sort(function (a, b) { return (a.tier || 0) - (b.tier || 0); });
      // The thread is the answer people came for, so it is the headline.
      var html = '<div class="ac-hero-fit__head">' +
        '<p class="ac-hero-fit__gun">' + esc(gun) + ' &middot; ' + esc(rec.caliber || state.cal) + '</p>' +
        (rec.thread
          ? '<p class="ac-hero-fit__answer">Your thread is <strong class="ac-hero-fit__thread-big">' + esc(rec.thread) + '</strong></p>'
          : '') +
        '</div>';

      if (rec.adapter) {
        var a = rec.adapter;
        var thumb = a.image ? '<img src="' + esc(a.image) + '" alt="" width="34" height="34" loading="lazy" decoding="async">' : '';
        var lead = a.sourced
          ? 'There\'s no off the shelf adapter for this one, so we source one for your gun'
          : 'Your muzzle needs the ' + esc(a.name);
        html += '<div class="ac-hero-fit__adapter">' + thumb +
          '<span class="ac-hero-fit__adapter-txt">' + lead + ', <strong>' + esc(a.price) + '</strong>. It goes in the cart with the can.</span>' +
          '<label><input type="checkbox" data-agc-hf-adapter' + (state.withAdapter ? ' checked' : '') + '> Include adapter</label>' +
          '</div>';
      } else {
        html += '<div class="ac-hero-fit__adapter"><span class="ac-hero-fit__adapter-ok">&#10003; Threads straight on. No adapter needed.</span></div>';
      }

      html += '<div class="ac-hero-fit__cards">';
      opts.forEach(function (o) {
        var size = (o.dia != null && o.len != null) ? ' <span class="ac-hero-fit__size">' + o.dia + '&Prime; &times; ' + o.len + '&Prime;</span>' : '';
        var dims = [];
        if (o.weightG) dims.push(o.weightG + ' g');
        if (!o.available) {
          html += '<div class="ac-hero-fit__card is-off">' +
            '<p class="ac-hero-fit__name"><span>' + esc(o.model) + size + '</span><span class="ac-hero-fit__price">' + esc(o.price || '') + '</span></p>' +
            '<p class="ac-hero-fit__dims">' + dims.join(' &middot; ') + '</p>' +
            '<p class="ac-hero-fit__why">' + esc(o.reason || 'Not made for this gun') + '</p>' +
            '</div>';
          return;
        }
        var blurb = BLURBS[o.key] || o.blurb || '';
        html += '<div class="ac-hero-fit__card" data-agc-hf-card="' + esc(o.key) + '">' +
          '<p class="ac-hero-fit__name"><span>' + esc(o.model) + size + '</span><span class="ac-hero-fit__price" data-agc-hf-price>' + esc(o.price) + '</span></p>' +
          '<p class="ac-hero-fit__dims">' + dims.concat(o.bore ? [esc(o.bore) + ' bore'] : []).join(' &middot; ') + '</p>' +
          (blurb ? '<p class="ac-hero-fit__blurb">' + esc(blurb) + '</p>' : '') +
          (o.note ? '<p class="ac-hero-fit__note">' + esc(o.note) + '</p>' : '') +
          '<div class="ac-hero-fit__actions">' +
            '<button type="button" class="ac-hero-fit__add" data-agc-hf-add="' + esc(o.key) + '"' + (o.items ? '' : ' disabled') + '>Add to cart</button>' +
            (o.url ? '<a class="ac-hero-fit__more" href="' + esc(o.url) + '">Details</a>' : '') +
          '</div>' +
          '</div>';
      });
      html += '</div>';

      html += '<div class="ac-hero-fit__foot">' +
        '<span>Prices are per can' + (rec.adapter ? '. The adapter is added to the cart with it.' : '.') + '</span>' +
        '<a class="ac-hero-fit__cartlink" href="/cart">View cart &rarr;</a>' +
        '</div>';

      showResult(html);
      result.classList.toggle('has-added', state.added);

      var adapterBox = result.querySelector('[data-agc-hf-adapter]');
      if (adapterBox) {
        adapterBox.addEventListener('change', function () {
          state.withAdapter = adapterBox.checked;
          track('build_change', { field: 'adapter', value: adapterBox.checked ? 'on' : 'off', gun: state.gun.label });
        });
      }
      result.querySelectorAll('[data-agc-hf-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-agc-hf-add');
          var o = opts.filter(function (x) { return x.key === key; })[0];
          if (o) addToCart(o, btn, rec);
        });
      });
      result.querySelectorAll('.ac-hero-fit__more').forEach(function (a) {
        a.addEventListener('click', function () { track('details', { gun: state.gun.label, cal: state.cal, model: a.closest('[data-agc-hf-card]').getAttribute('data-agc-hf-card') }); });
      });
    }

    function addToCart(o, btn, rec) {
      var items = (o.items || []).filter(function (it) {
        var isCan = it.properties && it.properties._item === 'can';
        return isCan || state.withAdapter;
      }).map(function (it) {
        var p = Object.assign({}, it.properties || {});
        p._fitfinder = 'hero';
        return Object.assign({}, it, { properties: p });
      });
      if (!items.length) return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) {
          if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error((e && e.description) || ('Cart error ' + r.status)); });
          return r.json();
        })
        .then(function () {
          state.added = true;
          btn.disabled = false; btn.textContent = '✓ Added'; btn.classList.add('is-done');
          result.classList.add('has-added');
          track('add_to_cart', { gun: state.gun.label, cal: state.cal, model: o.model, adapter: !!(rec.adapter && state.withAdapter), total: moneyVal(o.price) + (rec.adapter && state.withAdapter ? moneyVal(rec.adapter.price) : 0) });
          refreshCart();
          setTimeout(function () { btn.textContent = orig; btn.classList.remove('is-done'); }, 2600);
        })
        .catch(function (err) {
          btn.disabled = false; btn.textContent = orig;
          track('add_to_cart_failed', { error: String(err && err.message || err) });
          var e = document.createElement('p'); e.className = 'ac-hero-fit__err';
          e.textContent = 'Couldn\'t add that (' + (err.message || 'error') + '). Try the product page.';
          btn.closest('.ac-hero-fit__card').appendChild(e);
          setTimeout(function () { e.remove(); }, 6000);
        });
    }

    function refreshCart() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
          el.setAttribute('data-header-cart-count', cart.item_count);
        });
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      }).catch(function () {});
    }

    function showGap(msg, meta) {
      var html = '<p class="ac-hero-fit__msg">' + msg + '</p>' +
        '<div class="ac-hero-fit__gap" data-agc-hf-gap>' +
          '<input type="email" placeholder="you@email.com" autocomplete="email" autocorrect="off" autocapitalize="off" data-agc-hf-email>' +
          '<button type="button" data-agc-hf-gap-send>Send it to me</button>' +
        '</div>';
      showResult(html);
      var send = result.querySelector('[data-agc-hf-gap-send]');
      var email = result.querySelector('[data-agc-hf-email]');
      email.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send.click(); } });
      send.addEventListener('click', function () {
        if (!gapForm) return;
        var em = email.value.trim();
        gapForm.querySelector('[data-agc-f-gun]').value = meta.gun || '';
        gapForm.querySelector('[data-agc-f-cal]').value = meta.cal || '';
        gapForm.querySelector('[data-agc-f-email]').value = em;
        gapForm.querySelector('[data-agc-f-body]').value =
          'Fit finder gap (homepage hero). Airgun: ' + (meta.gun || '') + '. Caliber: ' + (meta.cal || '') + '. Reason: ' + (meta.reason || '') + '. Email: ' + (em || 'none');
        send.disabled = true; send.textContent = 'Sending…';
        fetch(gapForm.action, { method: 'POST', body: new FormData(gapForm), credentials: 'same-origin', redirect: 'manual' })
          .then(function () {
            result.querySelector('[data-agc-hf-gap]').innerHTML = '<span class="ac-hero-fit__ok">&#10003; Got it, thanks. ' + (em ? 'I\'ll email you once I have a fit.' : 'Your airgun is on the list.') + '</span>';
            track('gap_submit', { gun: meta.gun, cal: meta.cal, has_email: !!em, reason: meta.reason });
          })
          .catch(function () {
            send.disabled = false; send.textContent = 'Send it to me';
            var e = document.createElement('p'); e.className = 'ac-hero-fit__err'; e.textContent = 'Couldn\'t send. Email us at the address in the footer.';
            result.querySelector('[data-agc-hf-gap]').appendChild(e);
          });
      });
    }

    function showResult(inner) {
      result.innerHTML = '<div class="ac-hero-fit__panel">' + inner + '</div>';
      result.hidden = false;
      wrap.classList.add('has-result');
      result.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    function hideResult() {
      result.hidden = true; result.innerHTML = '';
      result.classList.remove('has-added');
      wrap.classList.remove('has-result');
    }

    syncFilled();

    try {
      var q0 = new URLSearchParams(location.search).get('gun');
      if (q0) { input.value = q0; syncFilled(); if (isInline()) search(q0.trim()); }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
